import { ApiContext } from './context';
import type { ApiContextType } from './types';

// Only export the component and hook from this file
export const ApiProvider: React.FC<{
    children: React.ReactNode;
    value: ApiContextType;
}> = ({ children, value }) => {
    return <ApiContext.Provider value={value}>{children}</ApiContext.Provider>;
};
